import { render, staticRenderFns } from "./ProjectHr.vue?vue&type=template&id=b5640f3e"
import script from "./ProjectHr.vue?vue&type=script&lang=js"
export * from "./ProjectHr.vue?vue&type=script&lang=js"
import style0 from "./ProjectHr.vue?vue&type=style&index=0&id=b5640f3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports